
import type { BlockRendererProps } from '@/lib/email-builder/block-registry';
import { parseBlockConfiguration } from '@/types/email-blocks';
import type { VideoBlockConfiguration } from '@/types/block-configurations';

export function VideoBlock({ block, isSelected, isHovered, onSelect, onHover }: BlockRendererProps) {
  const config = parseBlockConfiguration(block) as VideoBlockConfiguration;
  const width = config.width ?? 600;
  const displayWidth = Math.min(width, 560);
  const height = config.height ?? Math.round(displayWidth * 0.5625); // 16:9

  return (
    <div
      onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
      onMouseEnter={(e) => { e.stopPropagation(); onHover(block.id); }}
      onMouseLeave={() => onHover(null)}
      className={`
        lw-block-video cursor-pointer rounded transition-all
        ${isSelected ? 'ring-2 ring-primary ring-offset-2' : ''}
        ${isHovered && !isSelected ? 'ring-1 ring-muted-foreground/50' : ''}
      `}
      style={{
        paddingTop: `${config.padding?.top ?? 10}px`,
        paddingRight: `${config.padding?.right ?? 10}px`,
        paddingBottom: `${config.padding?.bottom ?? 10}px`,
        paddingLeft: `${config.padding?.left ?? 10}px`,
        textAlign: config.alignment?.horizontal || 'center',
      }}
    >
      <div
        className="relative inline-block overflow-hidden"
        style={{
          width: `${displayWidth}px`,
          height: `${height}px`,
          maxWidth: '100%',
          borderRadius: `${config.border?.radius ?? 0}px`,
          borderWidth: config.border?.width ? `${config.border.width}px` : '0',
          borderStyle: config.border?.style || 'solid',
          borderColor: config.border?.color || '#000000',
        }}
      >
        {config.thumbnailUrl ? (
          <img
            src={config.thumbnailUrl}
            alt={config.alt || 'Video thumbnail'}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-muted">
            <span className="text-sm text-muted-foreground">
              {config.provider !== 'native' ? `${config.provider} video` : 'Video'}
            </span>
          </div>
        )}
        {/* Play button overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-black/60">
            <svg className="h-6 w-6 text-white" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
